import React, { Fragment } from "react";
import "photoswipe/dist/photoswipe.css";
import { Gallery, Item } from "react-photoswipe-gallery";

const ImageRender = (props) => {
  const {
    imageUrl = "",
    thumbnailUrl = "",
    baseUrl = "",
    isGallery = false,
  } = props;
  let lastPart = baseUrl ? baseUrl.match(/[^/]*$/)[0] : "";
  let image = baseUrl
    ? lastPart
      ? `${baseUrl}/${imageUrl}`
      : `${baseUrl}${imageUrl}`
    : imageUrl;
  let thumbnail = lastPart
    ? lastPart === "/"
      ? `${baseUrl}${thumbnailUrl}`
      : `${baseUrl}/${thumbnailUrl}`
    : thumbnailUrl;
  return (
    <Fragment>
      <Gallery withDownloadButton>
        <Item original={image} thumbnail={thumbnail} width="1024" height="768">
          {({ ref, open }) => (
            <figure
              className={isGallery ? "col-md-2" : "col-md-3"}
              itemProp="associatedMedia"
              itemScope=""
            >
              <div
                ref={ref}
                onClick={open}
                style={{
                  backgroundImage: `url(${image})`,
                  width: 120,
                  height: 120,
                  cursor: "pointer",
                  position: "relative",
                  backgroundSize: "cover",
                  backgroundPosition: "50%",
                  backgroundRepeat: "no-repeat",
                  border: "1px solid black",
                }}
              ></div>
            </figure>
          )}
        </Item>
      </Gallery>
    </Fragment>
  );
};

export default ImageRender;
